<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            class="mr-3"
                            :disabled="is_livs_system || !this.$checkRole(this.$accessModule.parts_replacement, 'update') || !$checkRole($accessModule.allow_reject_incoming, 'allow_reject_incoming') || (Item && Item.status == 'Rejected')"
                            @click="rejectItem"
                            label="REJECT"
                            outline>
                        </gofix-button>
                        <gofix-button
                            :disabled="is_livs_system || !this.$checkRole(this.$accessModule.parts_replacement, 'update') || (Item && (Item.status == 'Rejected' || Item.status == 'DORJ Endorsed' || Item.status == 'Invoice Endorsed'))"
                            class="mr-3" label="NEXT ACTION"
                            @click="modalAction()" outline>
                        </gofix-button>
                        <gofix-button
                            :disabled="is_livs_system || !this.$checkRole(this.$accessModule.parts_replacement, 'update') || (Item && Item.status == 'Rejected')"
                            @click="checkValidateDORJ"
                            label="SAVE">
                        </gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card title=" " classContent="mb-0">
                            <b-row>
                                <b-col md="12">
                                    <b-row align-v="center">
                                        <b-col md="6">
                                            <gofix-form-input label="Lift Code" v-model="part_replacement.lift_code"></gofix-form-input>
                                        </b-col>
                                        <b-col md="2">
                                            <gofix-text-field class-label="width-120" label="Status" oneline>{{ part_replacement.status }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="4" v-if="part_replacement.reasons && part_replacement.reasons.reference_value_text">
                                            <gofix-text-field label="Reason Code" oneline>{{ part_replacement.reasons.reference_value_text }}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="2" class="mb-20">
                                    <gofix-text-field class-label="width-120" label="Lift Company" oneline>{{ part_replacement.lift_company ? part_replacement.lift_company : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="2" class="mb-20">
                                    <gofix-text-field class-label="width-120" label="Constituency" oneline>{{ part_replacement.constituency ? part_replacement.constituency : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="2" class="mb-20">
                                    <gofix-text-field class-label="width-120" label="Lift Number" oneline>{{ part_replacement.lift_number ? part_replacement.lift_number : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="6" class="mb-20">
                                    <gofix-text-field class-label="width-120" label="Blk Address" oneline>{{ part_replacement.blk_address ? part_replacement.blk_address : '' }}</gofix-text-field>
                                </b-col>
                                <!-- <b-col md="2" class="mb-25">
                                    <gofix-text-field class-label="width-120" label="McoID" oneline>{{ part_replacement.mco_id ? part_replacement.mco_id : '' }}</gofix-text-field>
                                </b-col> -->
                            </b-row>
                            <b-row align-v="center">
                                <b-col md="2">
                                    <gofix-form-input-date 
                                        label="Lift Warranty Expiry Date"
                                        disabled
                                        v-model="part_replacement.warranty_expiry">
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="2" class="mb-25">
                                    <gofix-text-field class-label="width-120" label="TMS Batch No" oneline>{{ part_replacement.tms_batch_no ? part_replacement.tms_batch_no : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="2" class="mb-25">
                                    <gofix-text-field class-label="width-120" label="TMS Batch Date" oneline>{{ part_replacement.tms_batch_date ? part_replacement.tms_batch_date : '' | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--') }}</gofix-text-field>
                                </b-col>
                                <b-col md="6" class="mb-25">
                                    <gofix-text-field class-label="width-120" label="TMS Lift ID" oneline>{{ part_replacement.tms_lift_id ? part_replacement.tms_lift_id : '' }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-input label="DORJ Number" v-model="part_replacement.dorj_number"></gofix-form-input>
                                </b-col>
                                 <b-col md="4">
                                    <gofix-form-input-date 
                                        label="DORJ Date" 
                                        popoverDirection="top"
                                        v-model="part_replacement.dorj_date" >
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                label="Lift Brand"
                                                v-model="part_replacement.lift_brand"
                                                vLabel="name"
                                                :reduce="option => option.name"
                                                required
                                                :options="liftBrandOption">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <!-- <b-col md="6">
                                            <gofix-form-input-date 
                                                label="Repl.Date" 
                                                popoverDirection="top"
                                                v-model="part_replacement.replacement_date" >
                                            </gofix-form-input-date>
                                        </b-col> -->
                                    </b-row>
                                </b-col>
                                <b-col md="8">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input label="Invoice Number" v-model="part_replacement.invoice_ref"></gofix-form-input>
                                        </b-col>
                                        <b-col md="3">
                                            <gofix-form-input-date 
                                                label="Invoice Date" 
                                                v-model="part_replacement.invoice_date" >
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="3">
                                            <gofix-form-input-date 
                                                label="Payment Date" 
                                                v-model="part_replacement.payment_date" >
                                            </gofix-form-input-date>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Invoice Type"
                                                vLabel="reference_value_text"
                                                v-model="part_replacement.invoice_type"
                                                required
                                                :options="invoice_type_options">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Job Type"
                                                v-model="part_replacement.job_type"
                                                required
                                                :options="rep_type_options">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="8">
                                    <b-row>
                                        <b-col md="3">
                                            <gofix-form-input label="Work Order Number" v-model="part_replacement.wo_ref_no"></gofix-form-input>
                                        </b-col>
                                        <b-col md="3">
                                            <gofix-form-input-date 
                                                label="Work Order Date" 
                                                v-model="part_replacement.wo_date" >
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input label="Remarks" v-model="part_replacement.remarks"></gofix-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                        label="GL Code"
                                                        :options="COA"
                                                        v-model="part_replacement.gl_code"
                                                        vLabel="name"
                                                        :disabled="part_replacement.status && (part_replacement.status != 'Draft' && part_replacement.status != 'Accepted')"
                                                        :filterable="false"
                                                        @search="searchCOA">
                                                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                        <div class="flex">
                                                            <div class="">
                                                                {{ option.gl_code + " " + option.name }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                                                        <span>{{ option.gl_code + " " + option.name }}</span>
                                                    </template>
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input disabled label="Data Source From" v-model="part_replacement.data_source_from"></gofix-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="8">
                                    <b-row align-v="center">
                                        <b-col md="6">
                                            <gofix-form-input-date 
                                                label="Acknowledgement Date" 
                                                v-model="part_replacement.acknowledged_on" >
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="5">
                                            <gofix-form-input label="Job Inspection By" v-model="part_replacement.job_inspection_by"></gofix-form-input>
                                        </b-col>
                                        <b-col md="1">
                                            <b-button variant="light" class="c-orange" @click="showHistoryJobInspectionBy"><i class="fa fa-history"></i></b-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input-date 
                                                label="Job Inspection Date" 
                                                v-model="part_replacement.job_inspection_date" >
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input label="Job Inspection Remarks" v-model="part_replacement.job_inspection_remarks"></gofix-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="8">
                                    <b-row align-v="center">
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Part Category"
                                                v-model="part_replacement.part_category"
                                                vLabel="name"
                                                :reduce="option => option.name"
                                                :options="rep_cat_options">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Supplier"
                                                v-model="part_replacement.supplier"
                                                vLabel="name"
                                                :options="supplierProvider">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-input label="Request Reference No" v-model="part_replacement.request_reference_no"></gofix-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>

                        <gofix-card class="mb-0" fullContent>
                            <gofix-default-table
                                :settings="tableConfig"
                                :table-items="tableItems"
                                :tbody-tr-class="rowClass"
                                @load-items="getTableData"
                                @new-item="newItem"
                                @row-click="rowClick"
                                @delete-items="deleteItems"
                                ref="gofixTable">
                                <template slot="gofix_table:id" slot-scope="row">
                                    {{ row.index + 1 }}
                                </template>
                                <template slot="gofix_table:replacement_date" slot-scope="row">
                                    {{ row.item.replacement_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--') }}
                                </template>
                                <template slot="gofix_table:last_replacement_date" slot-scope="row">
                                    {{row.item.lastReplaceDate  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--')}}
                                </template>
                                <template slot="gofix_table:description" slot-scope="row">
                                    <div v-html="$options.filters.showDescriptionTable(row.item.description, row.item.description_two)"></div>
                                </template>
                                <template slot="gofix_table:unit_price" slot-scope="row">
                                    {{ row.item.unit_price  | formatMoney }}
                                </template>
                                <template slot="gofix_table:total_value" slot-scope="row">
                                    {{ row.item.total_value  | formatMoney }}
                                </template>
                                <template slot="gofix_table:age" slot-scope="row">
                                    {{ row.item.last_replacement_date | calculatedAge }}
                                </template>
                                <template slot="gofix_table:warranty" slot-scope="row">
                                    <strong>{{ row.item.replace_within_warranty ? "W" : null }}</strong>
                                </template>
                                <template slot="gofix_table:bottom-row" slot-scope="row">
                                    <td v-for="(field, i) in row.data.fields" :key="i" :class="field.tdClass || ''">
                                        <div v-if="field.key === 'unit_price'" class="value font-weight-bold">Total</div>
                                        <div v-if="field.key === 'total_value'" class="value font-weight-bold">{{ totalValue | formatMoney }}</div>
                                    </td>
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                        <b-modal 
                            :no-close-on-backdrop="true" 
                            title="Add Part Replacement" 
                            id="modal-PartReplacement"
                            hide-footer 
                            :centered="true" 
                            size="xl"
                            v-model="modal.create.open">
                            <b-row class="mb-16">
                                <b-col md="12">
                                    <!--<gofix-form-dropdown
                                        label="Part Number"
                                        vLabel="sor_code"
                                        :filterable="false"
                                        :append-to-body="true"
                                        @search="searchSOR"
                                        v-model="modal.create.data.sor"
                                        required
                                        :options="modal.sor.items">
                                    </gofix-form-dropdown>-->
                                   <gofix-form-dropdown
                                        class="fakeTable"
                                        label="Part Number"
                                        vLabel="sor_code"
                                        :filterable="false"
                                        @search="searchSOR"
                                        required
                                        v-model="modal.create.data.sor"
                                        :options="modal.sor.items">
                                    <template #gofixInput:dropdown:list-header>
                                        <div class="d-table fakeTableHeader">
                                            <div class="d-table-cell cell itemTitle itemCode">Code</div>
                                            <div class="d-table-cell cell itemTitle itemSorGroup">SOR Group</div>
                                            <div class="d-table-cell cell itemTitle itemDescription">Description</div>
                                            <div class="d-table-cell cell itemTitle itemUnitPrice text-right">Unit Price</div>
                                            <div class="d-table-cell cell itemTitle itemUnitPrice text-right">Effective Date</div>
                                            <div class="d-table-cell cell itemTitle itemUom">UOM</div>
                                        </div>
                                    </template>
                                    <template #gofixInput:dropdown:option="{ sor_code , description_one, description_two, sor_group, unit_of_measurement, unit_price, effective_date}">
                                        <div class="d-table fakeTableBody">
                                            <div class="d-table-cell cell itemValue itemCode">{{sor_code}}</div>
                                            <div class="d-table-cell cell itemValue itemSorGroup">{{sor_group ? sor_group.description_one : null}}</div>
                                            <div class="d-table-cell cell itemValue itemDescription">
                                                {{description_one}} <span class="color-red" v-if="description_two"> - {{description_two}}</span>
                                            </div>
                                            <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{ unit_price | formatMoney}}</div>
                                            <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{ effective_date | formatDatebyMoment("YYYY-MM-DD  HH:mm:ss","DD.MM.YYYY")}}</div>
                                            <div class="d-table-cell cell itemValue itemUom">{{unit_of_measurement}}</div>
                                        </div>
                                    </template>
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <hr class="w-100 mt-5 mb-20" />
                            <b-row>
                                <b-col md="12" class="mb-16">
                                    <gofix-text-field class-label="min-width-105" label="Description" oneline >
                                        <div v-html="showDescription"></div>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row class="mb-20 align-items-center">
                                <b-col md="6">
                                    <b-row class="align-items-center">
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Last Replacement" oneline>{{ modal.create.data.last_replacement_date ? modal.create.data.last_replacement_date : '--' }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Last Warranty Expiry" oneline>{{  modal.create.data.warranty_expiry ? modal.create.data.warranty_expiry : '--' }}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Unit Price" oneline>{{ modal.create.data.unit_price ? modal.create.data.unit_price : '--' }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Total Price" oneline>{{ modal.create.data.total_value ? modal.create.data.total_value : '--' }}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                 </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3">
                                    <!--<gofix-form-input
                                        label="Repl. Location" 
                                        v-model="modal.create.data.replaced_location">
                                    </gofix-form-input>-->
                                    <gofix-form-dropdown
                                        label="Repl. Location"
                                        v-model="modal.create.data.replaced_location"
                                        required
                                        vLabel="name"
                                        @search="searchPartLocation"
                                        :options="optionPartLocation">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="3">
                                    <gofix-form-input-date 
                                        label="Repl. Date" 
                                        desc=" "
                                        popoverDirection="top"
                                        v-model="modal.create.data.replacement_date" >
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input v-model="modal.create.data.remarks" label="Remarks"></gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="2">
                                    <gofix-form-input-number 
                                        label="Quantity" 
                                        v-model="modal.create.data.quantity">
                                    </gofix-form-input-number>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-dropdown
                                        label="UOM"
                                        v-model="modal.create.data.unit_of_measurement"
                                        required
                                        :options="optionUOM">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-number 
                                        label="Discount ($)" 
                                        v-model="modal.create.data.discount"
                                        @input="discountValue"
                                        prefix="$"
                                        desc="">
                                    </gofix-form-input-number>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-number 
                                        label="Discount (%)" 
                                        v-model="modal.create.data.discount_percent"
                                        @input="discountPercent"
                                        suffix="%"
                                        desc="">
                                    </gofix-form-input-number>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input label="DORJ Number" v-model="modal.create.data.dorj_number"></gofix-form-input>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-date 
                                        label="DORJ Date" 
                                        desc=" "
                                        popoverDirection="top"
                                        v-model="modal.create.data.dorj_date" >
                                    </gofix-form-input-date>
                                </b-col>
                            </b-row>
                            <b-button-group class="d-block text-right pr-4">
                                <gofix-button label="SUBMIT" @click="checkBeforeCreateItem" :disabled="modal.create.loading" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>

                        <b-modal 
                            :no-close-on-backdrop="true"
                            id="modal-Address"
                            title="Address"
                            hide-footer
                            :centered="true" 
                            v-model="modal.address.open">
                            <b-form class="pb-10">
                                <gofix-form-input label="Address" v-model="address"></gofix-form-input>
                            </b-form>
                            <b-button-group class="d-block text-right">
                                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                        <!--Modal update-->
                        <b-modal 
                            :no-close-on-backdrop="true" 
                            title="Detail Part Replacement" 
                            id="modal-PartReplacement"
                            hide-footer 
                            :centered="true" 
                            size="xl"
                            v-model="modal.update.open">
                            <b-row class="mb-16">
                                <b-col md="12">
                                    <!--<gofix-form-dropdown
                                        label="Part Number"
                                        vLabel="sor_code"
                                        :filterable="false"
                                        :append-to-body="true"
                                        @search="searchSOR"
                                        v-model="modal.update.data.part_number"
                                        required
                                        :options="modal.sor.items">
                                    </gofix-form-dropdown>-->
                                    <gofix-form-dropdown
                                        class="fakeTable"
                                        label="Part Number"
                                        vLabel="sor_code"
                                        :filterable="false"
                                        @change="onChangeSor"
                                        @search="searchSOR"
                                        required
                                        :disabled="true"
                                        v-model="modal.update.data.sor"
                                        :options="modal.sor.items">
                                    <template #gofixInput:dropdown:list-header>
                                        <div class="d-table fakeTableHeader">
                                            <div class="d-table-cell cell itemTitle itemCode">Code</div>
                                            <div class="d-table-cell cell itemTitle itemSorGroup">SOR Group</div>
                                            <div class="d-table-cell cell itemTitle itemDescription">Description</div>
                                            <div class="d-table-cell cell itemTitle itemUnitPrice text-right">Unit Price</div>
                                            <div class="d-table-cell cell itemTitle itemUnitPrice text-right">Effective Date</div>
                                            <div class="d-table-cell cell itemTitle itemUom">UOM</div>
                                        </div>
                                    </template>
                                    <template #gofixInput:dropdown:option="{ sor_code , description_one, description_two, sor_group, unit_of_measurement, unit_price, effective_date}">
                                        <div class="d-table fakeTableBody">
                                            <div class="d-table-cell cell itemValue itemCode">{{sor_code}}</div>
                                            <div class="d-table-cell cell itemValue itemSorGroup">{{sor_group ? sor_group.description_one : null}}</div>
                                            <div class="d-table-cell cell itemValue itemDescription">
                                                {{description_one}} <span class="color-red" v-if="description_two"> - {{description_two}}</span>
                                            </div>
                                            <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{ unit_price | formatMoney}}</div>
                                            <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{ effective_date | formatDatebyMoment("YYYY-MM-DD  HH:mm:ss","DD.MM.YYYY")}}</div>
                                            <div class="d-table-cell cell itemValue itemUom">{{unit_of_measurement}}</div>
                                        </div>
                                    </template>
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <hr class="w-100 mt-5 mb-20" />
                            <b-row>
                                <b-col md="12" class="mb-16">
                                    <gofix-text-field class-label="min-width-105" label="Description" oneline>
                                        <div v-html="$options.filters.showDescriptionTable(modal.update.data.description, modal.update.data.description_two)"></div>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row class="mb-20 align-items-center">
                                <b-col md="6">
                                    <b-row class="align-items-center">
                                        <b-col md="6">
                                            <b-row class="align-items-center">
                                                <b-col md="9" class="pr-0">
                                                    <gofix-text-field class-label="min-width-105" label="Last Replacement" oneline>{{ modal.update.data.lastReplaceDate | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", 'DD.MM.YYYY', '--')}}</gofix-text-field>
                                                </b-col>
                                                <b-col md="3" class="pl-0" v-if="this.$checkRole(this.$accessModule.parts_replacement, 'update') && part_replacement.status === 'Draft'">
                                                    <b-button variant="light" class="c-orange" v-b-popover.hover.top="'Edit'" @click="showModalLastReplace"><i class="icon-note icons"></i></b-button>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Warranty Expiry" oneline>{{ modal.update.data.warranty_expiry ? `${modal.update.data.warranty_expiry}` : '--' }}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Unit Price" oneline>{{ modal.update.data.unit_price ? modal.update.data.unit_price : '--' }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field class-label="min-width-105" label="Total Price" oneline>{{ modal.update.data.total_value ? modal.update.data.total_value : '--' }}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                 </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3">
                                    <gofix-form-dropdown
                                        label="Repl. Location"
                                        v-model="modal.update.data.replaced_location"
                                        required
                                        vLabel="name"
                                        @search="searchPartLocation"
                                        :disabled="allowDisableField"
                                        :options="optionPartLocation">
                                    </gofix-form-dropdown>
                                    <!--<gofix-form-input
                                        disabled
                                        label="Repl. Location" 
                                        v-model="modal.update.data.replaced_location">
                                    </gofix-form-input>-->
                                </b-col>
                                <b-col md="3">
                                    <gofix-form-input-date 
                                        label="Repl. Date" 
                                        desc=""
                                        :disabled="allowDisableField"
                                        required
                                        popoverDirection="top"
                                        v-model="modal.update.data.replacement_date" >
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input :disabled="allowDisableField" v-model="modal.update.data.remarks" label="Remarks"></gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-row>
                                        <b-col md="4">
                                            <gofix-form-input-number 
                                                label="Quantity" 
                                                required
                                                :disabled="allowDisableField"
                                                v-model="modal.update.data.quantity">
                                            </gofix-form-input-number>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-form-dropdown
                                                label="UOM"
                                                :disabled="allowDisableField"
                                                v-model="modal.update.data.unit_of_measurement"
                                                required
                                                :options="optionUOM">
                                            </gofix-form-dropdown>
                                         </b-col>
                                         <b-col md="4">
                                            <gofix-form-input-number 
                                                label="Discount ($)" 
                                                v-model="modal.update.data.discount"
                                                :disabled="allowDisableField"
                                                @input="discountValueUpdate"
                                                prefix="$"
                                                desc=" ">
                                            </gofix-form-input-number>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6">
                                    <b-row>
                                        <b-col md="4">
                                            <gofix-form-input-number 
                                                label="Discount (%)" 
                                                v-model="modal.update.data.discount_percent"
                                                :disabled="allowDisableField"
                                                @input="discountPercentUpdate"
                                                suffix="%"
                                                desc=" ">
                                            </gofix-form-input-number>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-form-input :disabled="allowDisableField" label="DORJ Number" v-model="modal.update.data.dorj_number"></gofix-form-input>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-form-input-date 
                                                label="DORJ Date" 
                                                desc=" "
                                                :disabled="allowDisableField"
                                                popoverDirection="top"
                                                v-model="modal.update.data.dorj_date" >
                                            </gofix-form-input-date>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-button-group class="d-block text-right pr-4">
                                <gofix-button label="SUBMIT" @click="updateItem" :disabled="is_livs_system || modal.update.loading" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal id="modal-Remove" :no-close-on-backdrop="true"  title="Continue" hide-footer hide-header :centered="true" v-model="confirm.open">
                            <div class="center px-3">
                                <p>The current replacement date is less than the warranty expiration date<br/>{{ this.warranty_expiry | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", 'DD.MM.YYYY', null)}}</p>
                            </div>
                            <b-button-group class="btn-group">
                                <b-button class="custom-btn" @click="confirm.open = false">No</b-button>
                                <b-button class="custom-btn" @click="checkActiveWarrantyItem">Yes</b-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal id="modal-RemoveAlert" :no-close-on-backdrop="true"  title="Continue" hide-footer hide-header :centered="true" v-model="toast.open">
                            <div class="center px-3">
                                <p><strong>{{ toast.equipment_tag }}</strong></p>
                                <!--<span>Do you want to proceed?</span>-->
                            </div>
                            <b-button-group class="btn-group">
                                <b-button class="custom-btn" @click="toast.open = false">Cancel</b-button>
                                <!--<b-button class="custom-btn" @click="saveItem">Yes
                                </b-button>-->
                            </b-button-group>
                        </b-modal>
                        <b-modal 
                            id="modal-Create" 
                            size="lg" 
                            title="Reason" 
                            no-close-on-backdrop
                            hide-footer 
                            centered
                            v-model="modal.cancel.open">
                            <b-row>
                                <b-col>
                                    <b-form class="formV2">
                                        <gofix-form-dropdown
                                            label="Reason Code"
                                            vLabel="reference_value_text"
                                            v-model="modal.cancel.reason_id"
                                            :reduce="option => option.id"
                                            required
                                            :options="optionReasonCode" />
                                        <b-button-group class="d-block text-right">
                                            <gofix-button label="SUBMIT" @click="updateStatusItem" noBorder />
                                        </b-button-group>
                                    </b-form>
                                </b-col>
                            </b-row>
                        </b-modal>
                        <b-modal id="modal-Remove" :no-close-on-backdrop="true"  title="Continue" hide-footer hide-header :centered="true" v-model="modal.checkWarranty.open">
                            <div class="center px-3">
                                <p>You are repalicing an item with active warranty</p>
                            </div>
                            <b-button-group class="btn-group">
                                <b-button class="custom-btn" @click="modal.checkWarranty.open = false">No</b-button>
                                <b-button class="custom-btn" @click="createItem(true)">Yes, proceed</b-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal 
                            id="modal-Create" 
                            size="lg" 
                            title="History Of Job Inspection By" 
                            no-close-on-backdrop
                            hide-footer 
                            centered
                            @hidden="modal.history.data = null"
                            v-model="modal.history.open">
                            <b-row>
                                <b-col>
                                    <b-form class="formV2">
                                        <gofix-form-dropdown
                                            label="Job Inspection By"
                                            vLabel="reference_value_text"
                                            v-model="modal.history.data"
                                            :reduce="option => option.reference_value_text"
                                            :options="modal.history.options" />
                                        <b-button-group class="d-block text-right">
                                            <gofix-button label="APPLY" @click="storeJobInspectionBy" noBorder />
                                        </b-button-group>
                                    </b-form>
                                </b-col>
                            </b-row>
                        </b-modal>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <Activities ref="itemActivities" name-table="part-replacement-activity-log" activityType="Parts Replacement" :activityId="$route.params.part_replacement_id" :controls="{create: false, update: true, delete: false}" />
                    </template>
                    <template slot="gofixTab:part-location">
                        <Part-Location/>
                    </template>
                    <template slot="gofixTab:attachment">
                        <gofix-attachment :Item="part_replacement" :attachable_type="'parts_replacement_history'" classCard="mb-0" isShowAttachmentType nameTable="part-replacement-attachment-list" />
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" size="md" title="Actions" hide-footer :centered="true" ref="modal-change-status" v-model="nextAction.status">
            <b-row>
                <b-col>
                    <b-form class="formV2">
                        <gofix-form-dropdown
                            label="Next Available Actions"
                            vLabel="text"
                            :reduce="option => option.value"
                            v-model="nextAction.value"
                            :options="nextAction.list" />
                        <b-button-group class="d-block text-right">
                            <gofix-button label="SUBMIT" noBorder @click="saveModalAction()" />
                        </b-button-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" :title="''" hide-footer hide-header :centered="true" v-model="modalConfirm.status">
            <div class="center pb-30"> Proceed with the endorsement of this document? </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modalConfirm.status = false">No</b-button>
                <b-button class="custom-btn" @click="submitAddStamp()" :disabled="modalConfirm.loading">
                    <b-spinner v-if="modalConfirm.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.process.title" hide-footer :centered="true" v-model="modal.process.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modal.process.text}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
        <b-modal id="modal-Remove" :no-close-on-backdrop="true"  title="Continue" hide-footer hide-header :centered="true" v-model="modal.lastReplace.open">
            <div class="center py-3">
                <p class="mb-2">Please visit this hyperlink and update the Repl. Date field to update <br> this Last Replacement</p>
                <h5 @click="gotoLastReplace" class="underline cursor-pointer" v-if="modal.update.data.last_replace">{{modal.update.data.last_replace.dorj_number}}</h5>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.lastReplace.open = false">Cancel</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    const Activities = () => import("../global/Activities")
    const PartLocation = () => import("./part-location")
    const Attachment = () => import('@/views/attachments/list')
    import { PDFDocument } from 'pdf-lib';
    import jsPDF from 'jspdf'; 
    import { defineStampInsertPdf } from "@/_commonVar.js";
    import moment from 'moment';
    
    export default {
        name: 'parts-replacement-detail',
        components: {
            Activities,
            PartLocation,
            Attachment
        },
        props: {
            nameTable: {
                type: String,
                default: 'part-replacement-history-asset-management-detail-listing'
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['parts_replacement']));
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                    {
                        key: "part-location",
                        title: "Parts Location",
                        active: false
                    },
                    {
                        key: "attachment",
                        title: "Attachments",
                        active: false
                    }
                ],
                tableItems: [],
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: this.$checkRole(this.$accessModule.parts_replacement, 'create'),
                        delete: this.$checkRole(this.$accessModule.parts_replacement, 'delete'),
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
            	modal: {
                    warning:{
                        open: false,
                        loading: false,
                        timer: null
                    },
                    sor: {
                        items: [],
                        timer: null
                    },
                    detail: {
                        loading: false,
                        timer: null
                    },
            		create: {
                        open: false,
                        loading: false,
                        timer: null,
                        data: {
                            sor: null,
                            last_replacement_date: null,
                            last_replacement_date_show: null,
                            warranty: null,
                            unit_price: null,
                            total_value: null,
                            dorj_number: null,
                            dorj_date: null,
                            replacement_date: null,
                            quantity: 1,
                            discount: null,
                            unit_of_measurement:null,
                            warranty_expiry:null,
                            remarks:null,
                            discount_percent:null
                        },
                    },
                    update: {
                        open: false,
                        loading: false,
                        timer: null,
                        data: {
                            sor: null,
                            last_replacement_date: null,
                            last_replacement_date_show: null,
                            warranty: null,
                            unit_price: null,
                            total_value: null,
                            dorj_number: null,
                            dorj_date: null,
                            replacement_date: null,
                            quantity: null,
                            discount: null,
                            warranty_expiry:null,
                            unit_of_measurement:null,
                            replaced_location:null,
                            remarks:null,
                            discount_percent:null,
                            warranty_expiry:null,
                            last_replace: null
                        },
                    },
                    address: {
                        open: false,
                    },
                    cancel: {
                        open: false,
                        reason_id: null
                    },
                    checkWarranty: {
                        open: false
                    },
                    history: {
                        open: false,
                        options: [],
                        data: null,
                    },
                    process: {
                        title: 'Endorse DORJ',
                        open: false,
                        text: null,
                    },
                    stamping: {
                        loading: false,
                        open: false,
                        replacementModel: null,
                        type: null,
                        ids: [],
                        attachments: [],
                        timer: null
                    },
                    lastReplace: {
                        open: false
                    },
            	},
                nextAction: {
                    status: false,
                    list: [],
                    value: '',
                    gl_name: '',
                    nextActionStatus: {
                        "Draft": [
                            {
                                text: "Accept",
                                value: "Accepted"
                            }
                        ],
                        "Accepted": [
                            {
                                text: "Endorse DORJ",
                                value: "DORJ Endorsed"
                            },
                            {
                                text: "Draft",
                                value: "Draft"
                            }
                        ],
                        "Invoiced": [
                            {
                                text: "Endorse Invoice",
                                value: "Invoice Endorsed"
                            }
                        ]
                    }
                },
                modalConfirm: {
                    status: false,
                    loading: false,
                },
                warranty_expiry:null,
            	invoice_type_options: ['MINOR', 'MAJOR', 'OTHERS'],
                rep_type_options: ['Normal', 'Cyclical'],
                option_status: ['Draft', 'Verified', 'Rejected'],
                optionReasonCode: [],
                contract: null,
            	part_replacement: {
                    contract_id: null,
            		lift_company: null,
            		invoice_ref: null,
            		invoice_date: null,
                    payment_date: null,
                    remarks: null,
            		job_type: null,
            		invoice_type: null,
            		lift_code: null,
                    lift_number: null,
            		constituency: null,
            		division: null,
                    blk_address: null,
                    mco_id:null,
                    dorj_number:null,
                    dorj_date:null,
                    replacement_date:null,
                    gl_code:null,
                    wo_ref_no:null,
                    lift_brand:null,
                    status: null,
                    acknowledged_on: null,
                    attachments: [],
                    job_inspection_by: null,
                    job_inspection_date: null,
                    job_inspection_remarks: null,
                    part_category:null,
                    service_provider_id:null,
                    supplier:null,
                    warranty_expiry:null,
                    request_reference_no: null,
                    wo_date: null,
                    created_at: null
            	},
                address: null,
                parts: [],
                is_livs_system:false,
                optionUOM: null,
                optionPartLocation:[],
                data_default:null,
                confirm:{
                    open:false
                },
                toast:{
                    open:false,
                    equipment_tag:null
                },
                timer:null,
                liftBrandOption:[],
                brands:{
                    timer:null
                },
                allowDisableField:false,
                rep_cat_options:[],
                supplierProvider:[],
                glCode: null,
                glCodes: [],
                lastReplacementDates: [],
                userProfile: null,
                signatureImage: null,
                signatureImageUrl: null
            }
        },
        filters: {
            calculatedAge(val) {
                if(val) {
                    let now = moment();
                    let last_replacement_date = moment(val);
                    let months = now.diff(last_replacement_date, 'months');
                    if(months > 0) {
                        return now.diff(last_replacement_date, 'months') + ' months';
                    }
                }
                return '--';
            },
            showDescriptionTable(description_one, description_two) {
                let description = description_one;
                if(description_two) {
                    description += ` - <span class="color-red">${description_two}<span>`;
                }
                return description;
            }
        },
        created() {
            if (!this.$route.params.hasOwnProperty('part_replacement_id') || this.$route.params.part_replacement_id == "0" || isNaN(this.$route.params.part_replacement_id)) {
                return this.$router.push('/v2/parts-replacement');
            }
            this.getItem();
            // this.getGLCode();
            this.getListLiftManufacturer();
            this.getReplacementCategoryMaster();
            this.getSupplierProvider();
            this.setUserData();
        },
        computed: {
            totalValue() {
                let sum = 0;
                this.tableItems.map(item => {
                    sum += item.total_value;
                })
                return sum;
            },
            showDescription() {
                let description = '';
                if(this.modal.create.data.sor) {
                    description = this.modal.create.data.sor.description_one;
                    if(this.modal.create.data.sor.description_two) {
                        description += ` - <span class="color-red">${this.modal.create.data.sor.description_two}</span>`;
                    }
                }

                return description;
            },
            ...mapGetters({
                COA: 'FmCodeController/coa',
                Item: 'PartReplacementController/item',
                UserLogin: 'AuthController/user',
            })
        },
        watch: {
            contract: function(val) {
                if(val && val.id) {
                    this.getListSOR();
                }
            },
            "part_replacement.contract_id": function(val) {
                if(val) {
                    this.getContract();
                }
            },
            "modal.create.data.sor": function(val) {
                this.modal.create.data.unit_price  = val ? this.$accounting.formatMoney(val.unit_price) : null;
                this.modal.create.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(this.modal.create.data.unit_price, this.modal.create.data.quantity, this.modal.create.data.discount));
                if(val){
                    if(this.modal.create.data.replaced_location){
                        this.getItemLastReplacement(this.modal.create.data.replaced_location, val.id, 'add');
                    }else{
                        this.modal.create.data.last_replacement_date = null
                        this.modal.create.data.warranty_expiry = null
                    }
                    this.modal.create.data.unit_of_measurement = val.unit_of_measurement
                    if(this.modal.create.data.discount_percent) this.discountPercent(this.modal.create.data.discount_percent)
                } else {
                    this.modal.create.data.discount = null;
                    this.modal.create.data.discount_percent = null;
                    this.modal.create.data.total_value = 0;
                }
            },
            "modal.create.data.quantity": function(val) {
                let unit_price = this.modal.create.data.sor && this.modal.create.data.sor.unit_price ? this.modal.create.data.sor.unit_price : 0;
                this.modal.create.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.create.data.quantity, this.modal.create.data.discount));
            },
            "modal.update.data.quantity": function(val) {
                if(!val || val == '0'){
                    this.modal.update.data.total_value = 0
                    return
                }
                let unit_price = this.modal.update.data.unit_price ? this.modal.update.data.unit_price : 0;
                this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, val, this.modal.update.data.discount));
            },
            /*"modal.update.data.discount": function(val) {
                if(!this.modal.update.data.quantity || this.modal.update.data.quantity == '0'){
                    this.modal.update.data.total_value = 0
                    return
                }
                let unit_price = this.modal.update.data.unit_price ? this.modal.update.data.unit_price : 0;
                this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.update.data.quantity, val));
            },*/
            "modal.create.data.replaced_location": function(val){
                if(val && this.modal.create.data.sor){
                    this.getItemLastReplacement(val, this.modal.create.data.sor.id, 'add');
                }else{
                    this.modal.create.data.last_replacement_date = null
                }
            },
            "modal.update.data.replaced_location": function(val){
                if(val && this.modal.update.data.sor_item_id){
                    this.getItemLastReplacement(val, this.modal.update.data.sor_item_id, 'update');
                }else{
                    this.modal.update.data.last_replacement_date = null
                }
            },
            UserLogin: function(val){
                this.setUserData()
            }
        },
        methods: {
            rowClass(item) {
                if (item && item.replace_within_warranty) return "row-warranty"
            },
            onChangeSor(val){
               if(val && val.id && val.id != this.modal.update.data.sor_item_id){
                    this.modal.update.data.unit_price  = this.$accounting.formatMoney(val.unit_price);
                    this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(this.modal.update.data.unit_price, this.modal.update.data.quantity, this.modal.update.data.discount));
                    if(this.modal.update.data.replaced_location){
                        this.getItemLastReplacement(this.modal.update.data.replaced_location, val.id, 'update');
                    }else{
                        this.modal.update.data.last_replacement_date = null
                        this.modal.update.data.warranty_expiry = null
                    }
                    this.modal.update.data.quantity = 1
                    this.modal.update.data.replacement_date = this.part_replacement.replacement_date
                    this.modal.update.data.unit_of_measurement = val.unit_of_measurement
                    this.modal.update.data.remarks = null
                    this.modal.update.data.dorj_number = this.part_replacement.dorj_number
                    this.modal.update.data.dorj_date = this.part_replacement.dorj_date
                    this.modal.update.data.replaced_location = null
                    this.modal.update.data.discount = null
                }
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.livs_transaction_id = this.$route.params.part_replacement_id;
                await this.$store.dispatch("PartReplacementController/getDetailItems", tableRequest)
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);

                    this.lastReplacementDates = [];
                    if ( response.items ) {
                        response.items.forEach((item, i) => {
                            if ( item.lastReplaceDate ) {
                                this.lastReplacementDates.push( (i + 1) + '. Last Replacement Date: ' + moment(item.lastReplaceDate).format('DD/MM/YYYY'));
                            } else {
                                this.lastReplacementDates.push( (i + 1) + '. Last Replacement Date: NA');
                            }
                        });
                    }
                })
                .catch(err => {
                    this.$alertNotification("Can not load orders", "danger");
                    reject();
                });
            },
            getContract() {
                this.$store.dispatch('PartReplacementController/getContract', this.part_replacement.contract_id)
                .then(response => {
                    this.contract = response.data.data;
                })
                .catch(error => {})
            },
            async getListSOR(sftSor){
                await this.$store.dispatch( 'v2SorController/searchSorCode',
                [1, 100, '',
                        {
                        contract_term_id: this.contract.contract_terms[0] ? this.contract.contract_terms[0].id : null,
                        is_maintenance: false,
                        search: sftSor,
                        // brand: this.part_replacement.lift_company ? this.part_replacement.lift_company : null
                    },
                    this.contract ? this.contract.id : null,
                    '',
                    '',
                    {
                        sor_code: "asc",
                        effective_date: "desc"
                    }
                ])
                .then(response => {
                    this.modal.sor.items = response.data.data.items;
                    let arrayUOM = this.modal.sor.items.filter(function(item) {
                        return (item.unit_of_measurement != '' && item.unit_of_measurement != null);
                    }).map(function(obj) { return obj.unit_of_measurement; });
                    this.optionUOM = arrayUOM.filter((v, i, a) => a.indexOf(v) === i);
                })
                .catch(err => {})
            },
            async getPartLocation(keyword = null){
                this.$store.dispatch("PartReplacementController/getPartLocation", {
                    limit:-1,
                    page:1,
                    filter: {name: { type: 'text', value: keyword, function: "ilike"}},
                    isCMS:1
                }).then(response => {
                   let arrayPartLocation = response.items.map(function(obj) { return obj.name; });
                   this.optionPartLocation = arrayPartLocation;
                });
            },
            searchSOR(search, loading){
                loading(true);
                if(this.modal.sor.timer) {
                    clearTimeout(this.modal.sor.timer);
                }
                this.modal.sor.timer = setTimeout(async () => {
                    try {
                        await this.getListSOR(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                },300)
            },
            hanldeAddress() {
                this.part_replacement.blk_address = this.address;
                this.modal.address.open = false;
            },
            newItem() {
                this.modal.create.data =  {
                    sor: null,
                    replacement_date: null,
                    unit_price: null,
                    quantity: 1,
                    last_replacement_date: null,
                    replaced_location:null,
                    age: null,
                    discount:null
                };
                this.modal.create.open = true;
                if(this.data_default){
                    this.modal.create.data.dorj_number = this.data_default.dorj_number;
                    this.modal.create.data.dorj_date = this.data_default.dorj_date;
                    this.modal.create.data.replacement_date = this.data_default.replacement_date;
                }
                this.getPartLocation();
            },
            getItemLastReplacement(replaced_location, sor_id, action) {
                this.warranty_expiry = null;
                this.modal.create.data.warranty_expiry = null
                let tableRequest = {
                    filter: {
                        equipment_id: { type: 'number', value: this.part_replacement.equipment_id, function: '=', with: [] },
                        sor_item_id:  { type: 'number', value: sor_id, function: '=', with: [] },
                        livs_row_id:  { type: 'number', value: this.part_replacement.livs_transaction_id, function: '=', with: [] },
                        replaced_location: {type:'text', value: replaced_location, function: '=', with:[]}
                    },
                    limit: 1,
                    page: 1,
                    isCMS: 1,
                    sortColumn: 'replacement_date',
                    sortDirection: 'desc',
                    useDatabaseView: true
                }
                this.$store.dispatch("PartReplacementController/getPartReplacementHistory", tableRequest)
                .then(response => {
                    this.modal.create.data.age = null;
                    this.modal.create.data.last_replacement_date = null;
                    this.modal.update.data.last_replacement_date = null;
                    if(response.items.length == 1) {
                        let item = response.items[0];
                        this.warranty_expiry = item.warranty_expiry;
                        this.modal.create.data.warranty_expiry = moment(new Date(item.warranty_expiry)).format("DD.MM.YYYY");;
                        if(item.replacement_date) {
                           if(action == 'add'){
                                this.modal.create.data.last_replacement_date = moment(new Date(item.replacement_date)).format("DD.MM.YYYY");
                                this.modal.create.data.age = moment().diff(moment(item.replacement_date), 'months');
                            }else if(action == 'update'){
                                this.modal.update.data.last_replacement_date = moment(new Date(item.replacement_date)).format("DD.MM.YYYY");
                            }
                        }
                    }
                })
                .catch(err => {});
            },
            getItem() {
                this.$store.dispatch( 'PartReplacementController/getPartReplacement', this.$route.params.part_replacement_id)
                .then(response => {
                    this.part_replacement = Object.assign(this.part_replacement, response.data.data)
                    if(this.part_replacement.data_source_from && this.part_replacement.data_source_from === 'LIVS'){
                        this.is_livs_system = true;
                        this.tableConfig.controls.delete = false;
                        this.tableConfig.controls.create = false;
                    }
                    this.part_replacement.invoice_date = this.part_replacement.invoice_date ? new Date(this.part_replacement.invoice_date) : null;
                    this.part_replacement.payment_date = this.part_replacement.payment_date ? new Date(this.part_replacement.payment_date) : null;
                    this.part_replacement.dorj_date = this.part_replacement.dorj_date ? new Date(this.part_replacement.dorj_date) : null;
                    this.part_replacement.replacement_date = this.part_replacement.replacement_date ? moment(this.part_replacement.replacement_date).toDate() : null;
                    this.part_replacement.acknowledged_on = this.part_replacement.acknowledged_on ? moment(this.part_replacement.acknowledged_on).toDate() : null;
                    this.part_replacement.job_inspection_date = this.part_replacement.job_inspection_date ? moment(this.part_replacement.job_inspection_date).toDate() : null;
                    this.part_replacement.wo_date = this.part_replacement.wo_date ? moment(this.part_replacement.wo_date).toDate() : null;
                    this.part_replacement.warranty_expiry = this.part_replacement.warranty_expiry ? moment(this.part_replacement.warranty_expiry).toDate() : null;
                    this.data_default = Object.assign({},this.part_replacement);
                    if(this.part_replacement.gl_code || this.part_replacement.chart_of_account) {
                        this.part_replacement.gl_code = this.glCode = {
                            gl_code: this.part_replacement.gl_code || '',
                            chart_of_account: this.part_replacement.chart_of_account || null,
                            name: this.part_replacement.chart_of_account && this.part_replacement.chart_of_account.name ? this.part_replacement.chart_of_account.name : null,
                        }
                    }
                    this.part_replacement.created_at = this.part_replacement.created_at ? new Date(this.part_replacement.created_at) : null;
                    this.part_replacement.created_at = moment(this.part_replacement.created_at).format('DD/MM/YYYY');
                    
                    this.getGLCode();
                })
                .catch(err => {
                    this.$router.push('/v2/parts-replacement');
                })
            },
            async checkBeforeCreateItem(){
                if(!this.modal.create.data.sor) {
                    return this.$alertNotification("Please select part number before adding part replacement.", "danger");
                }

                if(!this.modal.create.data.replaced_location) {
                    return this.$alertNotification("Please select replaced location before adding part replacement.", "danger");
                }
                //check header save
                let result = await this.checkValidateDORJ(true);
                if(!result) return;

                this.confirm.open = false
                if(this.warranty_expiry && this.modal.create.data.replacement_date){
                    if(moment(this.modal.create.data.replacement_date).isBefore(this.warranty_expiry)){
                        //return this.$alertNotification("Replacement date must be greater than the warranty date " + moment(this.warranty_expiry).format("DD.MM.YYYY"), "danger");
                        this.confirm.open = true
                        return;
                    }
                }

                this.checkActiveWarrantyItem();
            },
            checkActiveWarrantyItem() {
                this.confirm.open = false
                 this.$store.dispatch( 'PartReplacementController/checkActiveWarranty', {
                    sor_item_id: this.modal.create.data.sor.id,
                    replaced_location: this.modal.create.data.replaced_location,
                    livs_transaction_id: this.part_replacement.livs_transaction_id
                }).then(result => {
                    if(result) return this.modal.checkWarranty.open = true
                    this.createItem();
                }).catch(err => {
                    // console.log(err);
                })
            },
            createItem(replace_within_warranty = false) {
                this.modal.checkWarranty.open = false
                if (this.modal.create.timer) {
                    clearTimeout(this.modal.create.timer);
                    this.modal.create.timer = null;
                }
                this.modal.create.timer = setTimeout(async () => {
                    let objeClone = {
                        sor_item_id: this.modal.create.data.sor.id,
                        livs_transaction_id: this.$route.params.part_replacement_id,
                        quantity: this.modal.create.data.quantity,
                        replaced_location: this.modal.create.data.replaced_location,
                        replacement_date: this.modal.create.data.replacement_date ? moment(this.modal.create.data.replacement_date).format("YYYY-MM-DD") : null,
                        dorj_number: this.modal.create.data.dorj_number,
                        dorj_date: this.modal.create.data.dorj_date ? moment(this.modal.create.data.dorj_date).format("YYYY-MM-DD") : null,
                        discount: this.modal.create.data.discount ? this.$accounting.unformat(this.modal.create.data.discount) : null,
                        unit_of_measurement: this.modal.create.data.unit_of_measurement,
                        remarks:this.modal.create.data.remarks,
                        replace_within_warranty: replace_within_warranty,
                    };
                    this.modal.create.loading = true;
                    this.$store.dispatch("PartReplacementController/createItemDetail", objeClone)
                    .then(response => {
                        this.modal.create.loading = false;
                        this.modal.create.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2('adding', 'parts_replacement'));
                    })
                    .catch(err => {
                        // this.modal.create.open = false;
                        this.modal.create.loading = false;
                        if (err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
                }, 200);
            },
            updateItem(){
                if (this.modal.update.timer) {
                    clearTimeout(this.modal.update.timer);
                    this.modal.update.timer = null;
                }
                this.modal.update.timer = setTimeout(async () => {
                    let objeClone = JSON.parse(JSON.stringify(this.modal.update.data));
                    if(!objeClone.replacement_date || !objeClone.quantity){
                        return this.$alertNotification("The field is required", "danger");
                    }
                    
                    delete objeClone['lastReplaceDate'];
                    delete objeClone['last_replacement_date'];
                    delete objeClone['last_replace'];

                    objeClone.replacement_date =  this.modal.update.data.replacement_date ? moment(this.modal.update.data.replacement_date).format("YYYY-MM-DD") : null;
                    objeClone.dorj_date =  this.modal.update.data.dorj_date ? moment(this.modal.update.data.dorj_date).format("YYYY-MM-DD") : null;
                    objeClone.discount = this.modal.update.data.discount ? this.$accounting.unformat(this.modal.update.data.discount) : null;
                    objeClone.unit_price = this.modal.update.data.unit_price ? this.$accounting.unformat(this.modal.update.data.unit_price) : null;
                    
                    if(this.modal.update.data.sor && this.modal.update.data.sor.id){
                        objeClone.sor_item_id = this.modal.update.data.sor.id;
                        objeClone.part_number = this.modal.update.data.sor.sor_code;
                        objeClone.description = this.modal.update.data.sor.description_one;
                        objeClone.description_two =   this.modal.update.data.sor.description_two;
                    }
                    delete objeClone['sor'];
                    delete objeClone['part_replacement_history'];
                    this.modal.update.loading = true;
                    this.$store.dispatch("PartReplacementController/updateItemDetail", objeClone)
                    .then(response => {
                        this.modal.update.loading = false;
                        this.modal.update.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2('editing', 'parts_replacement'));
                    })
                    .catch(err => {
                        // this.modal.update.open = false;
                        this.modal.update.loading = false;
                        if (err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
                }, 200);
            },
            rowClick(val){
                if(!this.$checkRole(this.$accessModule.parts_replacement, 'update')) return
                this.getPartLocation();
                if(val){
                    this.modal.update.data = Object.assign({}, val);
                    this.modal.update.data.unit_price  = this.modal.update.data.unit_price ? this.$accounting.formatMoney(this.modal.update.data.unit_price) : null;
                    this.modal.update.data.total_value  = this.modal.update.data.total_value ? this.$accounting.formatMoney(this.modal.update.data.total_value) : null;
                    this.modal.update.data.discount  = this.modal.update.data.discount ? this.$accounting.formatMoney(this.modal.update.data.discount) : null;
                    this.modal.update.data.dorj_date = val.dorj_date ? new Date(val.dorj_date) : null
                    this.modal.update.data.replacement_date = val.replacement_date ? new Date(val.replacement_date) : null
                    this.modal.update.data.warranty_expiry = val.warranty_expiry ? moment(val.warranty_expiry).format("DD.MM.YYYY") : null
                    this.modal.update.data.sor = {
                        id: this.modal.update.data.sor_item_id,
                        sor_code: this.modal.update.data.part_number
                    };
                    if(val.discount){
                        this.modal.update.data.discount_percent = this.$accounting.toFixed(((val.discount)/(val.total_value + val.discount)*100), 1) + '%';
                    }
                }
                this.modal.update.open = true
            },
            async deleteItems(callback) {
                const {
                    ids,
                    filter,
                    resolve,
                    reject
                } = await callback();
                await this.$store.dispatch('PartReplacementController/deleteItems', ids)
                .then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    resolve(this.$notificationV2('deleting', 'parts_replacement'))
                })
                .catch(err => {
                    reject();
                })
            },
            saveItem(showMessage = false) {
                if (this.modal.detail.timer) {
                    clearTimeout(this.modal.detail.timer);
                    this.modal.detail.timer = null;
                }
                this.modal.detail.timer = setTimeout(async () => {
                    this.modal.detail.loading = true;
                    let objeClone = JSON.parse(JSON.stringify(this.part_replacement));
                    if(objeClone.status == "Rejected" && !this.modal.cancel.reason_id) {
                        return this.$alertNotification("Reason Code is required", "danger");
                    }
                    objeClone.invoice_date = objeClone.invoice_date ? moment(objeClone.invoice_date).format("YYYY-MM-DD") : null
                    objeClone.payment_date = objeClone.payment_date ? moment(objeClone.payment_date).format("YYYY-MM-DD") : null
                    objeClone.dorj_date = objeClone.dorj_date ? moment(objeClone.dorj_date).format("YYYY-MM-DD") : null
                    objeClone.replacement_date = objeClone.replacement_date ? moment(objeClone.replacement_date).format("YYYY-MM-DD") : null
                    objeClone.acknowledged_on = objeClone.acknowledged_on ? moment(objeClone.acknowledged_on).format("YYYY-MM-DD") : null
                    objeClone.reason_id = this.modal.cancel.reason_id || null;
                    objeClone.job_inspection_date = objeClone.job_inspection_date ? moment(objeClone.job_inspection_date).format("YYYY-MM-DD") : null
                    objeClone.wo_date = objeClone.wo_date ? moment(objeClone.wo_date).format("YYYY-MM-DD") : null
                    objeClone.service_provider_id = objeClone.supplier ? objeClone.supplier.id:null;
                    objeClone.warranty_expiry = objeClone.warranty_expiry ? moment(objeClone.warranty_expiry).format("YYYY-MM-DD") : null
                    objeClone.gl_code = objeClone.gl_code && objeClone.gl_code.gl_code ? objeClone.gl_code.gl_code : null
                    delete objeClone.contract;
                    delete objeClone.attachments;
                    delete objeClone.reasons;
                    delete objeClone.supplier;
                    this.$store.dispatch("PartReplacementController/updateItem", objeClone)
                    .then(response => {
                        this.modal.detail.loading = false;
                        this.modal.cancel.open    = false;
                        if(!showMessage)
                            this.$alertNotification(this.$notificationV2('editing', 'parts_replacement'));
                        // store history of job inspection by
                        if(objeClone.job_inspection_by) {
                            this.$store.dispatch(`ReferenceController/createItem`, {
                                reference_type: "History Of Job Inspection By",
                                reference_value_text: objeClone.job_inspection_by,
                            })
                        }
                        this.getItem();
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(err => {
                        this.modal.detail.loading = false;
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })
                }, 200);
            },
            calculateTotalValue(unit_price, quantity, discount) {
                unit_price = unit_price ? this.$accounting.unformat(unit_price) : 0;
                discount   = discount ? this.$accounting.unformat(discount) : 0;
                quantity   = quantity ? this.$accounting.unformat(quantity) : 0;
                return ( unit_price * quantity ) - discount;
            },
            calculateTotalDiscountValue(unit_price, quantity, discount){
                unit_price = unit_price ? this.$accounting.unformat(unit_price) : 0;
                discount   = discount ? this.$accounting.unformat(discount) : 0;
                quantity   = quantity ? this.$accounting.unformat(quantity) : 0;
                return ( unit_price * quantity * discount)/100;
            },
            calculateTotalDiscountPercent(unit_price, quantity, discount) {
                unit_price = unit_price ? this.$accounting.unformat(unit_price) : 0;
                discount   = discount ? this.$accounting.unformat(discount) : 0;
                quantity   = quantity ? this.$accounting.unformat(quantity) : 0;
                return ( discount * 100 )/(unit_price*quantity);
            },
            checkValidateDiscount(unit_price, quantity, discount){
                unit_price = unit_price ? this.$accounting.unformat(unit_price) : 0;
                discount   = discount ? this.$accounting.unformat(discount) : 0;
                quantity   = quantity ? this.$accounting.unformat(quantity) : 0;
                if(discount > (unit_price *quantity)){
                    return false;
                }
                return true;
            },
            discountValue(val){
                if(!this.modal.create.data.quantity || this.modal.create.data.quantity == '0'){
                    this.modal.create.data.total_value = 0
                    return
                }
                let unit_price = this.modal.create.data.sor && this.modal.create.data.sor.unit_price ? this.modal.create.data.sor.unit_price : 0;
                if(val){
                    let price = this.$accounting.unformat(val);
                    if(!this.checkValidateDiscount(unit_price,this.modal.create.data.quantity,price)){
                        this.modal.create.data.discount = null
                        this.modal.create.data.discount_percent = null;
                        this.modal.create.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.create.data.quantity, 0));
                        return;
                    }
                }
                this.modal.create.data.discount_percent = this.$accounting.toFixed((this.calculateTotalDiscountPercent(unit_price, this.modal.create.data.quantity, val)),1) + "%";
                this.modal.create.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.create.data.quantity, val));
                if(!val){
                    this.modal.create.data.discount_percent = null;
                }
            },
            discountValueUpdate(val){
                if(!this.modal.update.data.quantity || this.modal.update.data.quantity == '0'){
                    this.modal.update.data.total_value = 0
                    return
                }
                let unit_price = this.modal.update.data.unit_price ? this.modal.update.data.unit_price : 0;
                if(val){
                    let price = this.$accounting.unformat(val);
                    if(!this.checkValidateDiscount(unit_price,this.modal.update.data.quantity,price)){
                        this.modal.update.data.discount = null
                        this.modal.update.data.discount_percent = null;
                        this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.update.data.quantity, 0));
                        return;
                    }
                }
                this.modal.update.data.discount_percent = this.$accounting.toFixed((this.calculateTotalDiscountPercent(unit_price, this.modal.update.data.quantity, val)),1) + "%";
                this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.update.data.quantity, val));
                if(!val){
                    this.modal.update.data.discount_percent = null;
                }
            },
            discountPercent(val){
                if(!this.modal.create.data.quantity || this.modal.create.data.quantity == '0'){
                    this.modal.create.data.total_value = 0
                    return
                }
                let unit_price = this.modal.create.data.unit_price ? this.modal.create.data.unit_price : 0;
                if(val){
                    let percent = this.$accounting.unformat(val);
                    if(percent > 100){
                        this.modal.create.data.discount_percent = null;
                        this.modal.create.data.discount = null;
                        this.modal.create.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.create.data.quantity, 0));
                        return;
                    }
                }
                this.modal.create.data.discount = this.$accounting.formatMoney(this.calculateTotalDiscountValue(unit_price, this.modal.create.data.quantity, val));
                this.modal.create.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.create.data.quantity, this.modal.create.data.discount));
                if(!val){
                    this.modal.create.data.discount = null;
                }
            },
            discountPercentUpdate(val){
                if(!this.modal.update.data.quantity || this.modal.update.data.quantity == '0'){
                    this.modal.update.data.total_value = 0
                    return
                }
                let unit_price = this.modal.update.data.unit_price ? this.modal.update.data.unit_price : 0;
                if(val){
                    let percent = this.$accounting.unformat(val);
                    if(percent > 100){
                        this.modal.update.data.discount_percent = null;
                        this.modal.update.data.discount = null;
                        this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.update.data.quantity, 0));
                        return;
                    }
                }
                this.modal.update.data.discount = this.$accounting.formatMoney(this.calculateTotalDiscountValue(unit_price, this.modal.update.data.quantity, val));
                this.modal.update.data.total_value = this.$accounting.formatMoney(this.calculateTotalValue(unit_price, this.modal.update.data.quantity, this.modal.update.data.discount));
                if(!val){
                    this.modal.update.data.discount = null;
                }
            },
            async checkValidateDORJ(showMessage = false){
                let check = false;
                this.toast.equipment_tag = null
                this.toast.open = false
                if(this.part_replacement.contract_id && 
                this.part_replacement.lift_company && 
                this.part_replacement.dorj_number && 
                this.part_replacement.dorj_date){
                    let tableRequest = {
                        filter: {
                            contract_id: this.part_replacement.contract_id,
                            lift_company: this.part_replacement.lift_company,
                            dorj_number: this.part_replacement.dorj_number,
                        },
                        limit: 1,
                        isCMS: 0,
                    }
                    await this.$store.dispatch("PartReplacementController/getPartReplacementHistoryHeader", tableRequest)
                    .then(response => {
                        if(response.data.data.items.length > 0){
                            //this.toast.equipment_tag = response.data.data.items[0].equipment_tag
                            this.toast.equipment_tag = `Duplicate DORJ with DORJ Number(${this.part_replacement.dorj_number}) and Lift Company(${this.part_replacement.lift_company})`
                            if(response.data.data.items[0].equipment_id != this.part_replacement.equipment_id){
                                this.toast.open = true
                                check = true;
                            }
                        }
                    }).catch(err => { check = true; })
                }
                if(check){
                    return false;
                }
                if(this.part_replacement.status == "Rejected" && !this.part_replacement.reasons) {
                    this.getReasonForCancellation();
                    this.modal.cancel.open = true;
                } else this.saveItem(showMessage);

                return true;
            },
            async getGLCode(search = null){
                this.$store.dispatch("FmCodeController/getCOA",{limit: 100, filter: {
                    coa_company_id: this.part_replacement && this.part_replacement.contract && this.part_replacement.contract.finance_company && this.part_replacement.contract.finance_company.finance_company_id ? this.part_replacement.contract.finance_company.finance_company_id : null,
                    search: search
                }});
                // let work_type = null;
                // if(this.part_replacement.job_type == 'Normal') work_type = 'Reactive'
                // if(this.part_replacement.job_type == 'Cyclical') work_type = 'Preventive'
                // await this.$store.dispatch("FmCodeController/getFmCodeItems",{
                //     limit: 100,
                //     page: 1,
                //     contract_id: this.part_replacement.contract_id,
                //     filter: {
                //         work_type: work_type,
                //         service_category_name: this.part_replacement.part_category || null,
                //         gl_code: search
                //     }
                // })
                // .then(response => {
                //     this.glCodes = response.items
                // });
            },
            searchCOA(search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getGLCode(search)
                        await loading(false)
                    } catch (error) {
                        loading(false)
                    }
                }, 500);
            },
            searchPartLocation(search,loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch( 'PartReplacementController/getPartLocation', { limit: 100, filter: { search: search } })
                    .then(response => {
                        loading(false)
                    })
                    .catch(err=>{ loading(false) })
                }, 500);
            },
            getReasonForCancellation(){
                this.$store.dispatch("ReferenceController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "reference_value_text",
                    sortDirection: "DESC",
                    isCMS:0,
                    filter:{
                        reference_type:"Part Replacement Reason Code for Rejection",
                        contract_id: this.part_replacement.contract_id
                    }
                })
                    .then(response => {
                        this.optionReasonCode = response.items;
                    })
                    .catch(err => {
                        this.optionReasonCode = [];
                    })
            },
            getHistoryJobInspectionBy(){
                this.$store.dispatch("ReferenceController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "reference_value_text",
                    sortDirection: "DESC",
                    isCMS:0,
                    filter:{
                        reference_type:"History Of Job Inspection By"
                    }
                })
                    .then(response => {
                        this.modal.history.options = response.items;
                    })
                    .catch(err => {
                        this.modal.history.options = [];
                    })
            },
            showHistoryJobInspectionBy() {
                this.getHistoryJobInspectionBy();
                this.modal.history.open = true;
                this.modal.history.data = this.part_replacement.job_inspection_by;
            },
            storeJobInspectionBy() {
                this.modal.history.open = false;
                this.part_replacement.job_inspection_by = this.modal.history.data;
            },
            getListLiftManufacturer() {
                this.$store.dispatch("MasterBrandController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "name",
                    sortDirection: "ASC",
                    filter: {
                        contract_id: null,
                    }
                })
                    .then(response => {
                        this.liftBrandOption = response.items;
                    })
                    .catch(err => {
                        this.liftBrandOption = [];
                    })
            },
            getReplacementCategoryMaster(){
                this.$store.dispatch("MasterBrandController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "name",
                    sortDirection: "ASC",
                    isCMS:0,
                    filter: {
                        contract_id: null,
                    }
                })
                .then(response => {
                    this.rep_cat_options = response.items;
                })
                .catch(err => {
                    this.rep_cat_options = [];
                })
            },
            getSupplierProvider(){
                this.$store.dispatch("OrganizationController/getItems", {
                    page: 1,
                    limit: -1,
                    sortDirection: "ASC",
                    sortColumn:"name",
                    isCMS:0,
                    filter:{
                        is_supplier:true,
                    }
                })
                .then(response => {
                    this.supplierProvider = response.data.data.items;
                })
                .catch(err => {
                    this.supplierProvider = [];
                })
            },
            modalAction() {
                if(this.nextAction.nextActionStatus[this.part_replacement.status]) {
                    let staus = this.nextAction.nextActionStatus[this.part_replacement.status]
                    if(this.part_replacement.status == 'Draft' && !this.$checkRole(this.$accessModule.allow_accept_incoming, 'allow_accept_incoming')) staus = []
                    if(this.part_replacement.status == 'Accepted' && !this.$checkRole(this.$accessModule.allow_endorse_incoming, 'allow_endorse_incoming')) staus = []
                    this.nextAction.list = staus
                }
                this.nextAction.value  = null
                this.nextAction.status = true
            },
            saveModalAction() {
                if(!this.nextAction.value) {
                    this.$alertNotification("Next available actions is required", "danger")
                    return
                }

                this.nextAction.status = false
                
                switch(this.nextAction.value) {
                    case 'DORJ Endorsed':
                        //this.getFmCode();
                        this.modalConfirm.status = true
                        break;
                    case 'Invoice Endorsed':
                        //this.getFmCode();
                        this.modalConfirm.status = true
                        break;
                    case 'Rejected':
                        this.getReasonForCancellation();
                        this.modal.cancel.open = true;
                        break;
                    default:
                        this.updateStatusItem()
                }
            },
            submitAddStamp() {

                /* find gl name */
                this.nextAction.gl_name = this.part_replacement.chart_of_account && this.part_replacement.chart_of_account.name ? this.part_replacement.chart_of_account.name : ''

                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                if ( !this.part_replacement.dorj_number ) {
                    this.modalConfirm.status = false
                    return this.$alertNotification("DORJ Number required", "danger");
                }

                this.timer = setTimeout(async () => {
                    this.modal.stamping.open = false
                    this.processTime();
                    this.processAddStamp()
                }, 300);
            },
            addStamp(item) {
                return new Promise(async (resolve, reject) => {
                    
                    let params = {
                        url: item.url.original,
                        image_file_name: item.url.image_file_name,
                    };
                    
                    let response = await this.$store.dispatch("FileDownloadController/getFileNotDownload", params);
                    const existingPdfBytes = await response.arrayBuffer().then(buffer => buffer)
                    const pdfDoc = await PDFDocument.load(existingPdfBytes)

                    const pages = pdfDoc.getPages()
                    const firstPage = pages[0]

                    let lines = [];

                    /* check lenght gl code - 60010 Normal Repair / Escalator Non-Cyclical / LSS / ARD Repair */
                    let chart_of_account_name = this.glCode && this.glCode.chart_of_account ? this.glCode.chart_of_account.name : '';
                    let chart_of_account_name_final = '--';
                
                    chart_of_account_name_final = chart_of_account_name;

                    let height_plus = 0;
                    let arr_ = chart_of_account_name.split(' / ');

                    /* 3 line - 4 array */
                    if ( arr_.length == 4 ) {
                        
                        chart_of_account_name_final = arr_[2] + ' / ' + arr_[3];

                        lines.push({ text: arr_[0] + ' /', font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        lines.push({ text: arr_[1] + ' /', font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        height_plus = 14;
                    }

                    /* 2 line - 2 array */
                    if ( arr_.length == 2 ) {
                        chart_of_account_name_final = arr_[1];

                        lines.push({ text: arr_[0] + ' /', font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        height_plus = 7;
                    }

                    /* */
                    if ( chart_of_account_name.length >= 20 && arr_.length == 1 ) {
                        chart_of_account_name_final = '';

                        lines.push({ text: chart_of_account_name, font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        height_plus = 7;
                    }

                    /* */
                    for (let i = 0; i < defineStampInsertPdf.lines.length; i++) {

                        let textInsert = defineStampInsertPdf.lines[i].text;

                        textInsert = textInsert.replace('__A__', chart_of_account_name_final);
                        textInsert = textInsert.replace('__B__', this.part_replacement.job_type || '--');
                        textInsert = textInsert.replace('__C__', this.glCode ? this.glCode.gl_code : '--');
                        textInsert = textInsert.replace('__D__', this.part_replacement.contract.contract_name);
                        textInsert = textInsert.replace('__DATE__', `${moment().format('DD/MM/YYYY')}`);
                        
                        lines.push({ text: textInsert, font: defineStampInsertPdf.lines[i].text_style.font_size, lineHeight: defineStampInsertPdf.lines[i].text_style.line_height, fontWeight: defineStampInsertPdf.lines[i].text_style.font_weight});
                    }

                    let startingPositon = 50
                    let x = 50;
                    let y = 50;
                    let widthBorderOne = defineStampInsertPdf.border.border_width_01
                    let widthBorderTwo = defineStampInsertPdf.border.border_width_02
                    let radiusBorderOne = defineStampInsertPdf.border.border_radius_01
                    let heightBorderOne = defineStampInsertPdf.border.border_height_01 + height_plus
                    let heightBorderTwo = defineStampInsertPdf.border.border_height_02 + height_plus
                    let radiusBorderTwo = defineStampInsertPdf.border.border_radius_02

                    var doc = await new jsPDF("landscape");
                    doc.setTextColor( defineStampInsertPdf.text.color );
                    for(let i = 0; i < lines.length; i++) {
                        let item = lines[i];
                        doc.setFontSize(item.font);
                        doc.setFont(defineStampInsertPdf.text.font_family, defineStampInsertPdf.text.font_weight, item.fontWeight || 'normal');
                        
                        doc.text(item.text, x, startingPositon);
                        startingPositon = startingPositon + item.lineHeight - 8
                    }
                    doc.setFillColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    doc.setDrawColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    doc.setLineWidth(1);
                    doc.roundedRect(x - 5, y - 8, widthBorderOne, heightBorderOne, radiusBorderOne, radiusBorderOne, 'S')
                    doc.setLineWidth(3);
                    doc.roundedRect(x - 8, y - 11, widthBorderTwo, heightBorderTwo, radiusBorderTwo, radiusBorderTwo, 'S')
                    
                    /* add signature user */
                    if ( this.signatureImage && this.signatureImageUrl ) {
                        let paramsImg = {
                            url: this.signatureImageUrl,
                            image_file_name: this.signatureImage,
                        };

                        let arrSignatureImage = this.signatureImage.split('.')
                        let suffixImg = arrSignatureImage[arrSignatureImage.length - 1]
                        
                        let responseImg = await this.$store.dispatch("FileDownloadController/getFileNotDownload", paramsImg);
                        
                        let existingImg_ = await responseImg.arrayBuffer().then(buffer => buffer);
                        let existingImg = this.arrayBufferToBase64(existingImg_);
                        
                        doc.addImage('data:image/jpeg;base64,' + existingImg, suffixImg, 105, 70 + height_plus, 15, 15);
                    }

                    let stampPDFBytes = doc.output('arraybuffer');
                    const [stamp] = await pdfDoc.embedPdf(stampPDFBytes);
                    const stampDims = stamp.scale(0.8);
                    firstPage.drawPage(stamp, {
                        ...stampDims,
                        x: defineStampInsertPdf.position_x,
                        y: defineStampInsertPdf.position_y,
                    });

                    // Stamp System Received Date
                    let sDate_lines = [];
                    sDate_lines.push({ text: 'System Received Date', font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});
                    sDate_lines.push({ text: ' ', font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});
                    sDate_lines.push({ text: this.part_replacement.created_at, font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});

                    let sDate_startingPositon = 50
                    let sDate_x = 50;
                    let sDate_y = 50;
                    let sDate_widthBorderOne = 53
                    let sDate_radiusBorderOne = 5
                    let sDate_heightBorderOne = 22

                    var sDate_doc = await new jsPDF("landscape");
                    sDate_doc.setTextColor( defineStampInsertPdf.text.color );

                    let sDate_x_ = sDate_x;
                    for(let i = 0; i < sDate_lines.length; i++) {

                        let item = sDate_lines[i];
                        sDate_doc.setFontSize(item.font);
                        sDate_doc.setFont(defineStampInsertPdf.text.font_family, defineStampInsertPdf.text.font_weight, item.fontWeight || 'normal');

                        sDate_doc.text(item.text, sDate_x_, sDate_startingPositon );
                        
                        sDate_startingPositon = sDate_startingPositon + item.lineHeight - 8
                        sDate_x_ = sDate_x_ + 5
                    }

                    sDate_doc.setFillColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    sDate_doc.setDrawColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    sDate_doc.setLineWidth(1);
                    sDate_doc.roundedRect(sDate_x - 5, sDate_y - 8, sDate_widthBorderOne, sDate_heightBorderOne, sDate_radiusBorderOne, sDate_radiusBorderOne, 'S')
                    sDate_doc.setLineWidth(3);

                    const [sDate_stamp] = await pdfDoc.embedPdf(sDate_doc.output('arraybuffer'));
                    const sDate_stampDims = sDate_stamp.scale(0.8);
                    firstPage.drawPage(sDate_stamp, {
                        ...sDate_stampDims,
                        x: 120,
                        y: 380,
                    });

                    if ( this.part_replacement.job_type && this.part_replacement.job_type == 'Cyclical' ) {
                        /* Last Replacement Date */
                        if ( this.lastReplacementDates && this.lastReplacementDates.length > 0) {
                            /* */
                        } else {
                            this.lastReplacementDates.push('Last Replacement Date: NA');
                        }
                        
                        let position_y_plus = this.lastReplacementDates.length * 14 + 22
                        let lDate_lines = [];
                        
                        this.lastReplacementDates.forEach(function(item) {
                            lDate_lines.push({ text: item, font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});
                        })

                        let lDate_startingPositon = 50
                        let lDate_x = 50;
                        let lDate_y = 50;

                        var lDate_doc = await new jsPDF("landscape");
                        lDate_doc.setTextColor( defineStampInsertPdf.text.color );

                        for(let i = 0; i < lDate_lines.length; i++) {

                            let item = lDate_lines[i];
                            lDate_doc.setFontSize(item.font);
                            lDate_doc.setFont(defineStampInsertPdf.text.font_family, defineStampInsertPdf.text.font_weight, item.fontWeight || 'normal');

                            lDate_doc.text(item.text, lDate_x, lDate_startingPositon );
                            
                            lDate_startingPositon = lDate_startingPositon + item.lineHeight - 6
                        }

                        const [lDate_stamp] = await pdfDoc.embedPdf(lDate_doc.output('arraybuffer'));
                        const lDate_stampDims = lDate_stamp.scale(0.8);
                        firstPage.drawPage(lDate_stamp, {
                            ...lDate_stampDims,
                            x: defineStampInsertPdf.position_x,
                            y: defineStampInsertPdf.position_y + parseInt(position_y_plus),
                        });
                    }
                    
                    const pdfBytes = await pdfDoc.save()
                    resolve(pdfBytes)
                })
            },
            async processAddStamp() {
                const processAddStampPDF = new Promise(async (resolve, reject) => {
                    this.processTime('In the process of adding stamps to the pdf')
                    let ids = []
                    let attachments = [];
                    
                    for(let i = 0; i < this.part_replacement.attachments.length; i++){
                        let item = this.part_replacement.attachments[i];
                        
                        if ( item.image_content_type != 'application/pdf' ) {
                            continue;
                        }
                        
                        /* check file name dorj */
                        // let fileName = item.image_file_name.replace('.pdf', '');
                        // let arrFileName = fileName.split('-');
                        //  reference_value_text
                        // if ( this.part_replacement.dorj_number && (arrFileName && (arrFileName.length == 3 || (arrFileName.length == 4 && arrFileName[arrFileName.length-1].length == 2)))) {
                        //     let dorjNumber = arrFileName[1] + '/' + arrFileName[2];

                        //     if ( this.part_replacement.dorj_number.toLowerCase() ==  dorjNumber.toLowerCase() ) {
                        //         await this.addStamp(item, this.part_replacement.postal_code).then(result => {
                        //             attachments.push({
                        //                 id: item.id,
                        //                 reference_id: item.reference_id,
                        //                 file: new File([new Blob([result])], item.image_file_name, {type: 'application/pdf'})
                        //             })
                        //         })
                        //     }
                        // }
                        
                        // console.log(this.part_replacement.status, 'this.part_replacement.status')
                        // console.log(this.part_replacement.invoice_ref, 'this.part_replacement.invoice_ref')
                        // console.log(item.attachment_type.reference_value_text, 'item.attachment_type.reference_value_text')
                        
                        if ( this.part_replacement.status == 'Invoiced' && this.part_replacement.invoice_ref && item.attachment_type && item.attachment_type.reference_value_text && item.attachment_type.reference_value_text == 'Invoice document' ) {
                            await this.addStamp(item, this.part_replacement.postal_code).then(result => {
                                attachments.push({
                                    id: item.id,
                                    reference_id: item.reference_id,
                                    file: new File([new Blob([result])], item.image_file_name, {type: 'application/pdf'})
                                })
                            })
                        }
                       
                        if ( this.part_replacement.status == 'Accepted' && this.part_replacement.dorj_number && item.attachment_type && item.attachment_type.reference_value_text && item.attachment_type.reference_value_text == 'DORJ document' ) {
                            await this.addStamp(item, this.part_replacement.postal_code).then(result => {
                                attachments.push({
                                    id: item.id,
                                    reference_id: item.reference_id,
                                    file: new File([new Blob([result])], item.image_file_name, {type: 'application/pdf'})
                                })
                            })
                        }
                    }
                    
                    await resolve(attachments)
                });

                processAddStampPDF.then(attachments => {
                    this.processTime('In the process of endorse to item')
                    this.updateStatusItem(attachments);
                })
            },
            processTime(text = '') {
                this.modal.process.text = text
                
                this.modal.process.title = 'Endorse DORJ'
                if ( this.nextAction.value == "Invoice Endorsed" ) {
                    this.modal.process.title =  'Endorse Invoice'
                }

                this.modal.process.open = true
                this.modalConfirm.status = false
            },
            async updateStatusItem(attachments = []) {
                if(this.nextAction.value == "Rejected" && !this.modal.cancel.reason_id) {
                    return this.$alertNotification("Reason code is required", "danger");
                }
                
                let request = {
                    id: this.part_replacement.id,
                    livs_transaction_id: this.part_replacement.livs_transaction_id,
                    status: this.nextAction.value,
                    reason_id: this.modal.cancel.reason_id || null,
                    files: attachments,
                }

                await this.$store.dispatch('PartReplacementController/updateStatusPartsReplacement', request)
                .then(response => {
                    this.modal.cancel.open = false
                    this.$alertNotification(this.$notificationV2('editing', 'parts_replacement'))
                    if(this.nextAction.value == "DORJ Endorsed" || this.nextAction.value == "Invoice Endorsed") {
                        this.processTime('Successful')
                        this.modal.process.open = false
                    }
                    this.getItem()
                })
                .catch(err => {
                    this.modal.process.open = false
                    if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "danger");
                    }
                });
            },
            rejectItem() {
                this.nextAction.value = "Rejected"; /* Rejected | Accepted | Invoiced */
                this.saveModalAction()
            },
            async getFmCode() {
                let work_type = null;
                if(this.part_replacement.job_type == 'Normal') work_type = 'Reactive'
                if(this.part_replacement.job_type == 'Cyclical') work_type = 'Preventive'
                await this.$store.dispatch("FmCodeController/getFmCodeItems",{
                    limit: 1,
                    page: 1,
                    contract_id: this.part_replacement.contract_id,
                    filter: {
                        work_type: work_type,
                        service_category_name: this.part_replacement.part_category || null,
                        gl_code: this.part_replacement.gl_code ? this.part_replacement.gl_code.gl_code : ''
                    }
                })
                .then(response => {
                    this.glCode = null
                    if(response.items.length) {
                        this.glCode = response.items[0]
                    }
                });
            },
            setUserData() {
                if(this.UserLogin && this.UserLogin.id) {
                    this.$store.dispatch('v2UserController/getUser', this.UserLogin.id)
                    .then(response => {
                        
                        this.signatureImage = null
                        this.signatureImageUrl = null

                        if ( response.data.data && response.data.data.signature_image && response.data.data.signature_image[0] ) {
                            this.signatureImageUrl = response.data.data.signature_image[0].url.thumb
                            this.signatureImage = response.data.data.signature_image[0].image_file_name
                        }
                    })
                    .catch(error => {})
                }
            },
            arrayBufferToBase64( buffer ) {
                var binary = '';
                var bytes = new Uint8Array( buffer );
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode( bytes[ i ] );
                }
                return window.btoa( binary );
            },
            showModalLastReplace() {
                this.modal.lastReplace.open = true
                this.modal.update.open = false
            },
            gotoLastReplace() {
                if (this.modal.update.data.last_replace) {
                    this.modal.lastReplace.open = false
                    let routeData = this.$router.resolve({
                        name: 'parts-replacement-detail',
                        params: { part_replacement_id: this.modal.update.data.last_replace.livs_transaction_id }
                    })
                    window.open(routeData.href, '_blank');
                }
            }
        }
    }
</script>